import React, { useContext, useEffect, useState, Fragment } from 'react';
import Button from '../components/bronson/Button';
import Input from '../components/bronson/Input';
import Traductor from '../components/Traductor';
import Loading from '../components/bronson/Loading';
import '../components/css/Login.css';
import LoginService from '../services/LoginService';
import ParseService from '../services/ParseService';

function ForgotPasswordModuleComponent({ history, setRenderModuleType }) {
    const [errorList, setError] = useState({});
    const [email, setEmail] = useState('');
    const [UserId, setUserId] = useState('');
    const [loading, setLoading] = useState(false);
    const t = new Traductor();

    let optionsBtnCancelar = {
        text: t.getTraduction('Cancelar'),
        btnTypes: ['secondary'],
    };
    let optionsBtnSolicitar = {
        text: t.getTraduction('Solicitar'),
    };
    let optionsInputUser = {
        id: 'user',
        type: 'text',
        label: t.getTraduction('PlaceHolderUser'),
    };

    function CancelAction() {
        setRenderModuleType(1);
    }

    function onClick(e) {
        let newText = e.target.value;
        newText = newText.toString().replace(' ', '');
        switch (e.target.name) {
            case 'UserId':
                setUserId(newText);
                break;
            case 'email':
                setEmail(newText);
                break;
        }
    }

    const onChangeEmail = e => {
        setEmail(e);
        setError('');
    };

    const validate = email => {
        let isValid = true;
        let errorList = {};
        const strRegexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        if (email !== '' && strRegexEmail.test(email) === true) {
            errorList.email = '';
        } else if (email !== '' && strRegexEmail.test(email) === false) {
            errorList.email = 'Correo no valido';
            isValid = false;
        } else {
            errorList.email = 'El campo correo no puede estar vacio ';
            isValid = false;
        }
        setError(errorList);
        return isValid;
    };

    async function onSubmit(event) {
        event.preventDefault();
        let urlLocation = window?.location?.href;
        if (urlLocation.indexOf('remamobile')) {
            urlLocation = urlLocation.replace('remamobile', 'RemaMobile');
        }
        setLoading(true);

        if (validate(email)) {
            const options = {
                UserId: UserId,
                PathUrl: urlLocation,
                Email: email,
                Language: 'ESP',
                UserType: '0',
            };
            const response = await new LoginService().forgot(options);
            setLoading(false);
            if (response && response.Result == 'true') {
                document.getElementById('UserId').value = '';
                document.getElementById('email').value = '';
                alert(
                    t.getTraduction('EnvioMailSatisfactorioCambioContrasenya')
                );
            } else {
                alert(t.getTraduction('ErrorEnvioMailCambioContrasenya'));
            }
        }
    }

    const printUserIdInput = () => {
        let optionsInputUser = {
            id: 'UserId',
            name: 'UserId',
            type: 'text',
            event: true,
            label: t.getTraduction('PlaceHolderUser'),
        };
        return (
            <Input
                options={optionsInputUser}
                onChange={e => onChange(e)}
                onClick={e => onClick(e)}
            ></Input>
        );
    };

    const printEmailInput = () => {
        let optionsInputEmail = {
            id: 'email',
            name: 'email',
            type: 'text',
            event: true,
            label: t.getTraduction('PlaceHolderEmail'),
        };
        return (
            <Input
                options={optionsInputEmail}
                onChange={e => onChange(e)}
                onClick={e => onClick(e)}
            ></Input>
        );
    };

    function onChange(e) {
        if (e.target.name) {
            let newText = e.target.value;
            newText = newText.toString().replace(' ', '');
            switch (e.target.name) {
                case 'UserId':
                    setUserId(newText);
                    break;
                case 'email':
                    setEmail(newText);
                    break;
            }
        }
    }

    return (
        <Fragment>
            <div>
                <div>
                    <p>{t.getTraduction('ResetPassword')}</p>
                </div>
                <div className="o-fieldset__row">
                    {printUserIdInput()}
                    {printEmailInput()}
                    <p className="c-error-message" id="EmailError">
                        {errorList.email}
                    </p>
                </div>
                <div className="o-split">
                    <Button
                        options={optionsBtnCancelar}
                        onClick={CancelAction}
                    ></Button>
                    <Button
                        options={optionsBtnSolicitar}
                        onClick={onSubmit}
                    ></Button>
                </div>
            </div>
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
}
export default ForgotPasswordModuleComponent;
